'use strict';

(function () {
    'use strict';

    ckanService.$inject = ['$q'];
    angular.module('app.services').factory('ckanService', ckanService);

    function ckanService($q) {
        'ngInject';

        var service = {
            getDatasets: getDatasets
        };

        return service;

        function getDatasets() {
            return $q.when([{
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/i-poli',
                name_el: 'Η πόλη',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/i-poli',
                name_en: 'The city'
            }, {
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/nomika-prosopa',
                name_el: 'Νομικά πρόσωπα',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/nomika-prosopa',
                name_en: 'Legal entities'
            }, {
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/o-dimos',
                name_el: 'Ο Δήμος',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/o-dimos',
                name_en: 'The Municipality'
            }, {
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/oikonomika-stoixeia',
                name_el: 'Οικονομικά στοιχεία',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/oikonomika-stoixeia',
                name_en: 'Fiscal data'
            }, {
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/poleodomika-stoixeia',
                name_el: 'Πολεοδομικά στοιχεία',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/poleodomika-stoixeia',
                name_en: 'Urban planning'
            }, {
                url_el: 'http://smartcity.heraklion.gr/opendata/el/group/politismos',
                name_el: 'Πολιτισμός',
                url_en: 'http://smartcity.heraklion.gr/opendata/en/group/politismos',
                name_en: 'Arts and culture'
            }]);
        }
    }
})();